module.exports = __webpack_public_path__ + "img/quxian.b3dd8556.png";